import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useUsersList() {
  // Use toast
  const toast = useToast();

  const refUserListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "sale_id", label: "Order", sortable: true },
    { key: "sale_created", label: "Date", sortable: true },
    { key: "Office_name", label: "Office", sortable: true },
    { key: "customerId", label: "customer", sortable: true },
    { key: "employeeId", label: "Employee", sortable: true },
    { key: "actions" },
  ];
  const perPage = ref(10);
  const totalUsers = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const roleFilter = ref(null);
  const statusFilter = ref(null);
  const itemsOffices = ref([]);
  const itemsStatus = ref([]);
  const rangeDateFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value
      ? refUserListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    };
  });

  const refetchData = () => {
    refUserListTable.value.refresh();
  };

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      roleFilter,
      statusFilter,
      rangeDateFilter,
    ],
    () => {
      console.log("desde watch");
      refetchData();
    }
  );

  const fetchUsers = (ctx, callback) => {
    const { officeEmployee_officeId, rolId } = JSON.parse(
      localStorage.getItem("userData")
    ).dataUser;

    store
      .dispatch("app-user/fetchOrderCustomer", {
        q: searchQuery.value.toLowerCase(),
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        officeId: roleFilter.value,
        customerId: statusFilter.value,
        rangeDate: rangeDateFilter.value,
        rolId: rolId,
        officeId: officeEmployee_officeId,
      })
      .then((response) => {
        const { data, total } = response.data;
        callback(data);
        totalUsers.value = total;
        const arrayOffice = [];
        const arrayData = [];
        const setObj = new Set();
        const setObjOffice = new Set();
        if (total > 0) {
          data.map((data, item) => {
            if (!setObjOffice.has(data.Office_name)) {
              setObjOffice.add(data.Office_name, data);
              arrayOffice.push({
                label: data.Office_name,
                value: data.sale_officeId,
              });
            }

            if (!setObj.has(data.sale_customerId)) {
              setObj.add(data.sale_customerId, data);
              arrayData.push({
                label: `${data.customers_first_name} ${data.customers_last_name}`,
                value: data.sale_customerId,
                id: item,
              });
            }
          });

          itemsOffices.value = arrayOffice;
          itemsStatus.value = arrayData;
        }
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching users list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = (role) => {
    if (role === "subscriber") return "primary";
    if (role === "author") return "warning";
    if (role === "maintainer") return "success";
    if (role === "editor") return "info";
    if (role === "admin") return "danger";
    return "primary";
  };

  const resolveUserRoleIcon = (role) => {
    if (role === "subscriber") return "UserIcon";
    if (role === "author") return "SettingsIcon";
    if (role === "maintainer") return "DatabaseIcon";
    if (role === "editor") return "Edit2Icon";
    if (role === "admin") return "ServerIcon";
    return "UserIcon";
  };

  const resolveUserStatusVariant = (status) => {
    if (status === true) return "success";
    if (status === false) return "warning";
    return "success";
  };

  const dataItemOffice = itemsOffices;
  const dataItemStatus = itemsStatus;

  return {
    fetchUsers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    statusFilter,
    dataItemStatus,
    dataItemOffice,
    rangeDateFilter,
  };
}
